  document.addEventListener("DOMContentLoaded", function () {
   
//     document.querySelector('.new-mobile-btn')?.addEventListener('click', () => {
//   document.querySelector('facet-floating-filter button')?.click();
// });
    // const protectionVariantId = "40912835772451"; // replace this!

    // fetch("/cart.js")
    //   .then(response => response.json())
    //   .then(cart => {
    //     const alreadyAdded = cart.items.some(item => item.variant_id === protectionVariantId);
    //     if (!alreadyAdded) {
    //       fetch('/cart/add.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ id: protectionVariantId, quantity: 1 })
    //       }).then(() => {
    //         console.log("Package Protection added to cart.");
    //         // Optionally reload cart or update UI
    //       }).catch(error => {
    //         console.error("Error adding package protection:", error);
    //       });
    //     }
    //   });
// const protectionVariantId = 409128357724512;




    // $.getJSON('/cart.js', function (cart) {
    //   const items = cart.items;

    //   const protectionItem = items.find(item => item.variant_id === protectionVariantId);

    //   const hasPhysicalProducts = items.some(item => item.requires_shipping && item.variant_id !== protectionVariantId);
    //   const onlyProtectionLeft = items.length === 1 && items[0].variant_id === protectionVariantId;

    //   if ((onlyProtectionLeft || (!hasPhysicalProducts && protectionItem)) && protectionItem) {
    //     $.ajax({
    //       type: 'POST',
    //       url: '/cart/change.js',
    //       data: JSON.stringify({
    //         id: protectionItem.key,
    //         quantity: 0
    //       }),
    //       dataType: 'json',
    //       contentType: 'application/json',
    //       success: function (updatedCart) {
    //         console.log('Protection item removed');
    //         document.dispatchEvent(new CustomEvent('cart:refresh'));
    //         location.reload();
    //         location.href = location.href;
    //       },
    //       error: function (err) {
    //         console.error('Error removing protection item:', err);
    //       }
    //     });
    //   }
    // });
// $(document).on('click', '.item-remove', function () {
//   setTimeout(() => {
//     $.getJSON('/cart.js', function (cart) {
//       const items = cart.items;

//       const protectionItem = items.find(item => item.variant_id === protectionVariantId);

//       const hasPhysicalProducts = items.some(item => item.requires_shipping && item.variant_id !== protectionVariantId);
//       const onlyProtectionLeft = items.length === 1 && items[0].variant_id === protectionVariantId;

//       if ((onlyProtectionLeft || (!hasPhysicalProducts && protectionItem)) && protectionItem) {
//         $.ajax({
//           type: 'POST',
//           url: '/cart/change.js',
//           data: JSON.stringify({
//             id: protectionItem.key,
//             quantity: 0
//           }),
//           dataType: 'json',
//           contentType: 'application/json',
//           success: function (updatedCart) {
//             console.log('Protection item removed');
//             document.dispatchEvent(new CustomEvent('cart:refresh'));
//           },
//           error: function (err) {
//             console.error('Error removing protection item:', err);
//           }
//         });
//       }
//     });
//   },600);
// });



// function checkAndAddProtection() {
//   $.getJSON('/cart.js', function(cart) {
//     const hasProtection = cart.items.some(item => item.variant_id == protectionVariantId);

//     const physicalProductCount = cart.items.reduce((count, item) => {
//       if (item.variant_id !== protectionVariantId && item.requires_shipping) {
//         return count + item.quantity;
//       }
//       return count;
//     }, 0);

//     if (!hasProtection && physicalProductCount > 0) {
      
//       /* --- AUTO-ADDITION COMMENTED OUT ---
//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: JSON.stringify({
//           id: protectionVariantId,
//           quantity: 1
//         }),
//         contentType: 'application/json',
//         dataType: 'json',
//         success: function() {
//           console.log("✅ Package Protection added to cart.");
//           document.dispatchEvent(new CustomEvent('cart:refresh'));
//         },
//         error: function(err) {
//           console.error("❌ Failed to add Package Protection:", err);
//         }
//       });
//       */
//      console.log("ℹ️ Auto-addition of package protection is disabled.");

//     } else {
//       console.log("ℹ️ No physical products in cart or protection already present.");
//     }
//   }).fail(function(err) {
//     console.error("❌ Failed to fetch cart:", err);
//   });
// }


  // $('form[action="/cart/add"]').on('submit', function(e) {
  //   e.preventDefault();
    
  //   const $form = $(this);
  //   const formData = $form.serialize();

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: formData,
  //     dataType: 'json',
  //     success: function(response) {
  //       console.log("🎉 Product added:", response);
  //       checkAndAddProtection(); // Now check for and add protection if needed
  //     },
  //     error: function(err) {
  //       console.error("❌ Error adding product:", err);
  //     }
  //   });
  // });

  });

  /* ----------------------------------------------------------
     Cart drawer bfcache fix
     When the user goes to checkout and presses the browser back
     button, the page is restored from bfcache. The cart drawer's
     DOM was cleared during the checkout navigation so it can show
     empty even though the cart still has items.

     Fix: mark when a checkout form is submitted, then on pageshow
     with event.persisted (bfcache restore) reload the page so
     the cart renders fresh from the server.
  ---------------------------------------------------------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.querySelector('[name="checkout"]')) {
      sessionStorage.setItem('_leftForCheckout', '1');
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (sessionStorage.getItem('_leftForCheckout')) {
      sessionStorage.removeItem('_leftForCheckout');
      window.location.reload();
    }
  });

  /* ---------------------------------------------------------- */

  document.querySelector('[aria-controls="search-drawer"]')?.addEventListener('click', () => {
    // Set up a MutationObserver to wait for the drawer to appear
    const observer = new MutationObserver((mutations, obs) => {
      const drawer = document.querySelector('.drawer.show-close-cursor');
      if (drawer) {
        // Set a CSS variable to hide the overlay
        drawer.style.setProperty('--overlay-display', 'none');
        obs.disconnect(); // Stop observing once found
      }
    });

    // Start observing the body for child list changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    }); 
  });
  
function initializeProductSliders() {
    const sliderWrappers = document.querySelectorAll('.product-slider-wrapper');
  
    sliderWrappers.forEach(wrapper => {
      if (wrapper.classList.contains('slider-initialized')) return;
      wrapper.classList.add('slider-initialized');
  
      const slides = wrapper.querySelectorAll('.product-slider .slide');
      const dots = wrapper.querySelectorAll('.slider-dots .dot');
      const prevBtn = wrapper.querySelector('.slider-arrow.prev');
      const nextBtn = wrapper.querySelector('.slider-arrow.next');
      let current = 0;
  
      function showSlide(index) {
        slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === index);
          dots[i].classList.toggle('active', i === index);
        });
  
        prevBtn.style.opacity = index === 0 ? '0.4' : '1';
        nextBtn.style.opacity = index === slides.length - 1 ? '0.4' : '1';
  
        prevBtn.style.pointerEvents = index === 0 ? 'none' : 'auto';
        nextBtn.style.pointerEvents = index === slides.length - 1 ? 'none' : 'auto';
      }
  
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', () => {
          if (current > 0) {
            current--;
            showSlide(current);
          }
        });
  
        nextBtn.addEventListener('click', () => {
          if (current < slides.length - 1) {
            current++;
            showSlide(current);
          }
        });
      }
  
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index);
          current = index;
          showSlide(current);
        });
      });
  
      wrapper.addEventListener('mouseleave', () => {
        current = 0;
        showSlide(current);
      });
  
      showSlide(current);
    });
  }
  
  // Run on DOM ready
  // Run on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    const isDesktop = () => window.innerWidth >= 769;
console.log(window.innerWidth);
    // if(isDesktop()){
      initializeProductSliders();
      // enforceSingleSwatchSelection(); // Add this line

      // Set up MutationObserver to catch Shopify filter changes
      const observer = new MutationObserver(() => {
        initializeProductSliders();
        // enforceSingleSwatchSelection(); // And also add this line
      });

    const target = document.querySelector('#main-collection-product-grid') || document.body;
    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  // }
  });
  function enforceSingleSwatchSelection() {
  const productCards = document.querySelectorAll('.shopify-section--main-collection product-card');

  productCards.forEach(card => {
    // Find all swatches that are currently selected
    const selectedSwatches = card.querySelectorAll('.color-swatch.is-selected, .thumbnail-swatch.is-selected');

    // If there is more than one swatch selected, we need to clean up.
    if (selectedSwatches.length > 1) {
      let originalSwatch = card.querySelector('.is-selected.original');

      // If we found an 'original' swatch, it's the source of truth.
      // Remove 'is-selected' from all other swatches.
      if (originalSwatch) {
        selectedSwatches.forEach(swatch => {
          if (swatch !== originalSwatch) {
            swatch.classList.remove('is-selected');
          }
        });
      }
    }
  });
}
    

  const input = document.getElementById('search-input');

  input.addEventListener('input', function () {
    console.log('Searching for:', input.value);
  });

  document.querySelectorAll('.product-type-menu a').forEach(link => {
    link.addEventListener('mouseover', function () {
      const text = link.textContent.trim();
      input.value = text;

      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
  document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("search-input");
  const drawerFlex = document.querySelector(".drawer_flex");

  if (!input || !drawerFlex) return;

  input.addEventListener("input", () => {
    const hasText = input.value.trim().length > 0;
    drawerFlex.style.display = hasText ? "flex" : "none";
  });
});
// Watch for changes on the input
document.getElementById("search-input").addEventListener("input", function () {
  const value = this.value;

  // Use a slight delay or mutation observer to wait for AJAX completion
  setTimeout(() => {
    const addSearchDiv = document.getElementById("add_search");
    if (addSearchDiv) {
      addSearchDiv.textContent = value;
    }
  }, 300); // Delay may need adjusting based on AJAX speed
});
document.querySelectorAll('.sserch').forEach(button => {
  button.addEventListener('click', function () {
    setTimeout(() => {
      const scrollTop = window.scrollY || window.pageYOffset;
      const header = document.querySelector('.header');
      const announcement = document.querySelector('.announcement-bar');
      const searchDrawer = document.getElementById('search-drawer');

      if (!header || !searchDrawer) return;

      let topValue;

      if (scrollTop > 0) {
        // If not at top: only header height - 1
        topValue = (header.offsetHeight - 1) + 'px';
      } else {
        // If at top: header + announcement
        const announcementHeight = announcement ? announcement.offsetHeight : 0;
        topValue = (header.offsetHeight + announcementHeight - 1) + 'px';
      }

      // Set --header-height if needed
      document.documentElement.style.setProperty('--header-height', topValue);

      // Apply inline style with !important
      searchDrawer.style.setProperty('top', topValue, 'important');
    }, 1100);
  });
});

/*document.querySelectorAll('.mobile-nav-btn').forEach(button => {
    button.addEventListener('click', function () {
      setTimeout(() => {

      }, 2100);
    });
  }); */

  // sort by 
  // document.querySelectorAll('[role="option"][value]').forEach(option => {
  //   option.addEventListener('click', function () {
  //     const value = this.getAttribute('value');
  //     const url = new URL(window.location.href);
  //     url.searchParams.set('sort_by', value);
  //     window.location.href = url.toString();
  //   });
  // });

  // review 
  const observeStampedSelect = () => {
    const observer = new MutationObserver((mutations, obs) => {
      const select = document.getElementById('stamped-sort-select');
      if (select) {
        // Wrap it if not already wrapped
        let wrapper = select.closest('.custom-select-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'custom-select-wrapper';
          select.parentNode.insertBefore(wrapper, select);
          wrapper.appendChild(select);
        }

        // Add listeners
        select.addEventListener('focus', () => wrapper.classList.add('select-open'));
        select.addEventListener('blur', () => wrapper.classList.remove('select-open'));

        obs.disconnect(); // Stop observing once done
      }
    });

    // Start observing the document body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // Run on DOM ready
  document.addEventListener("DOMContentLoaded", () => {
     $(document).ready(function () {
    // Optional: observeStampedSelect();
    
    function closeAllAccordions(except) {
      $('.accordion-item.active').each(function () {
        if (this !== except[0]) {
          $(this).removeClass('active');
          $(this).find('.accordion-content').css('max-height', '');
          $(this).find('.accordion-icon').html(`
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M13 4V16M7 10H19" stroke="#1B1B1B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `);
        }
      });
    }

    $('.accordion-header').on('click', function () {
      const $item = $(this).closest('.accordion-item');
      const $content = $item.find('.accordion-content');
      const $icon = $(this).find('.accordion-icon');
      const isOpen = $item.hasClass('active');

      if (isOpen) {
        $item.removeClass('active');
        $content.css('max-height', '');
        $icon.html(`
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 1V13M1 7H13" stroke="#1B1B1B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `);
      } else {
        closeAllAccordions($item);
        $item.addClass('active');
        $content.css('max-height', $content[0].scrollHeight + 'px');
        $icon.html(`
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7 10H19" stroke="#1B1B1B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `);
      }
    });

    // Open the first accordion by default
    const $firstItem = $('.accordion-item').first();
    if ($firstItem.length) {
      $firstItem.addClass('active');
      const $firstContent = $firstItem.find('.accordion-content');
      const $firstIcon = $firstItem.find('.accordion-icon');

      $firstContent.css('max-height', $firstContent[0].scrollHeight + 'px');
      $firstIcon.html(`
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M7 10H19" stroke="#1B1B1B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `);
    }
  });
  });
  
  
  
  

  // end product
  // fonts
document.addEventListener("DOMContentLoaded", function () {
  function customizeShopifyInstallments() {
    // We use a timeout because the Shadow DOM loads asynchronously
    setTimeout(() => {
      const components = document.querySelectorAll('shopify-payment-terms');
      
      if(components.length === 0) return;

      components.forEach(component => {
        // Ensure shadowRoot exists before accessing it
        if (component && component.shadowRoot) {
          const shadowRoot = component.shadowRoot;

          // 1. Change Font
          const content = shadowRoot.querySelector('#shopify-installments-content');
          if (content) {
            content.style.setProperty("font-family", '"Montserrat", monospace', "important");
            content.querySelectorAll('*').forEach(el => {
              el.style.setProperty("font-family", '"Montserrat", monospace', "important");
            });
          }

          // 2. Hide "Learn more" / Prequal link
          // Note: Hiding legal links might violate Shop Pay TOS, use with caution
          const learnMore = shadowRoot.querySelector('#prequalBackupCTA');
          if (learnMore) {
            learnMore.style.display = 'none';
          }
        }
      });
    }, 2000); // Wait 2 seconds for widget to render
  }

  // Run on load
  customizeShopifyInstallments();

  // Run when variants change (Shopify often re-renders the form)
  document.addEventListener('variant:changed', function() {
    customizeShopifyInstallments();
  });
});
  // review option
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
      const nativeSelect = document.querySelector('#stamped-sort-select');
      if (nativeSelect && !nativeSelect.dataset.enhanced) {
        nativeSelect.dataset.enhanced = 'true';
  
        nativeSelect.style.display = 'none';
  
        const wrapper = document.createElement('div');
        wrapper.className = 'stamped-sort-select-wrappers custom-dropdowns';
  
        const trigger = document.createElement('div');
        trigger.className = 'dropdown-triggers';
        trigger.textContent = nativeSelect.options[nativeSelect.selectedIndex].text;
  
        const menu = document.createElement('div');
        menu.className = 'dropdown-menus';
  
        Array.from(nativeSelect.options).forEach((opt, index) => {
          const item = document.createElement('div');
          item.className = 'dropdown-items';
          item.textContent = opt.text;
  
          if (index === nativeSelect.selectedIndex) {
            item.classList.add('selected');
          }
  
          item.addEventListener('click', () => {
            nativeSelect.selectedIndex = index;
            trigger.textContent = opt.text;
            nativeSelect.dispatchEvent(new Event('change'));
  
            menu.querySelectorAll('.dropdown-items').forEach(i => i.classList.remove('selected'));
            item.classList.add('selected');
  
            menu.classList.remove('show');
            wrapper.classList.remove('open');
            menu.querySelectorAll('.dropdown-items').forEach(i => i.classList.remove('selected'));
item.classList.add('selected');
          });
  
          menu.appendChild(item);
        });
  
        wrapper.appendChild(trigger);
        wrapper.appendChild(menu);
        nativeSelect.parentNode.insertBefore(wrapper, nativeSelect.nextSibling);
  
        trigger.addEventListener('click', () => {
          menu.classList.toggle('show');
          wrapper.classList.toggle('open');
        });
  
        document.addEventListener('click', (e) => {
          if (!wrapper.contains(e.target)) {
            menu.classList.remove('show');
            wrapper.classList.remove('open');
          }
        });
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  });
  document.querySelectorAll('.redirect-item').forEach(item => {
    item.addEventListener('click', () => {
      const url = item.getAttribute('data-url');
      if (url) {
        window.location.href = url;
      }
    });
  });
  // const nativeSelect = document.getElementById('mobile-sort');
  // const customOptionsContainer = document.getElementById('custom-options');
  // const customButton = document.getElementById('custom-select-button');
  // const label = document.getElementById('custom-select-label');

  // // Populate custom options
  // function renderOptions() {
  //   customOptionsContainer.innerHTML = '';
  //   const selectedValue = nativeSelect.value;

  //   Array.from(nativeSelect.options).forEach(option => {
  //     const li = document.createElement('li');
  //     li.textContent = option.textContent;
  //     li.setAttribute('data-value', option.value);
  //     li.classList.add('custom-option');
  //     if (option.value === selectedValue) {
  //       li.classList.add('selected');
  //       label.textContent = option.textContent;
  //     }
  //     customOptionsContainer.appendChild(li);
  //   });
  // }

  // renderOptions();

  // // Toggle dropdown
  // customButton.addEventListener('click', () => {
  //   const isOpen = customOptionsContainer.style.display === 'block';
  //   customOptionsContainer.style.display = isOpen ? 'none' : 'block';
  // });

  // // Handle selection
  // customOptionsContainer.addEventListener('click', (e) => {
  //   if (!e.target.matches('li')) return;

  //   const value = e.target.getAttribute('data-value');
  //   nativeSelect.value = value;
  //   nativeSelect.form.submit(); // Triggers Shopify sort

  //   // Update UI
  //   renderOptions();
  //   customOptionsContainer.style.display = 'none';
  // });

  // // Close if click outside
  // document.addEventListener('click', function (e) {
  //   if (!customButton.contains(e.target) && !customOptionsContainer.contains(e.target)) {
  //     customOptionsContainer.style.display = 'none';
  //   }
  // });

  // document.addEventListener("DOMContentLoaded", function () {
  //   const clearAllTrigger = document.getElementById("clear-all");
  
  //   if (clearAllTrigger) {
  //     clearAllTrigger.addEventListener("click", function () {
  //       const tryClickClearAll = () => {
  //         const targetClearAll = document.querySelector(".facet-clear-all");
  //         if (targetClearAll) {
  //           targetClearAll.click();
  //           observer.disconnect(); // Stop observing after it's found
  //         }
  //       };
  
  //       // Try once in case it's already there
  //       tryClickClearAll();
  
  //       // If not, observe for changes
  //       const observer = new MutationObserver(tryClickClearAll);
  //       observer.observe(document.body, {
  //         childList: true,
  //         subtree: true,
  //       });
  //     });
  //   }
  // });
  document.addEventListener('click', function (e) {
    // Open mobile filter
    if (e.target.closest('.filter-mobile-open')) {
      setTimeout(() => {
        const scrollTop = window.scrollY || window.pageYOffset;
        const header = document.querySelector('.header');
        const announcement = document.querySelector('.announcement-bar');
        const mobileFacets = document.querySelector('.collection__facets_mobile');
  
        if (!header || !mobileFacets) return;
  
        if (window.innerWidth > 699) {
          let topValue;
  
          if (scrollTop > 0) {
            topValue = (header.offsetHeight + 1) + 'px';
          } else {
            const announcementHeight = announcement ? announcement.offsetHeight : 0;
            topValue = ((header.offsetHeight + announcementHeight) + 1) + 'px';
          }
  
          const heightValue = `calc(100vh - ${topValue})`;
  
          document.documentElement.style.setProperty('--header-height', topValue);
          mobileFacets.style.setProperty('top', topValue, 'important');
          mobileFacets.style.setProperty('height', heightValue, 'important');
        }
  
        mobileFacets.classList.add('open');
        document.body.classList.add('no-scroll');
      }, 100);
    }
  
    // Close mobile filter
    if (e.target.closest('.mobile_filter_close')) {
      const mobileFacets = document.querySelector('.collection__facets_mobile');
      if (mobileFacets) {
        mobileFacets.classList.remove('open');
        document.body.classList.remove('no-scroll');
      }
  
      // Simulate click on apply button if it exists
      const applyButton = document.querySelector('.facets-drawer__floating-apply button');
      if (applyButton) {
        applyButton.click();
      }
    }
  });
    //  collection accordian 
  
  document.addEventListener('DOMContentLoaded', function () {
    $(document).on('click', '.dropdown', function () {
      $(".benefits").slideToggle();
      $(this).toggleClass('rotated');
    });
    if($('.desktop_des')){

      // Read More clicked
      $('.read_more_des').on('click', function () {
        $('.mobile_des').animate({ opacity: 0 }, function () {
          $(this).css('display', 'none');
          $('.desktop_des').css('display', 'block').animate({ opacity: 1 });
        });
      });

      // Read Less clicked
      $('.read_less_des').on('click', function () {
        $('.desktop_des').animate({ opacity: 0 }, function () {
          $(this).css('display', 'none');
          $('.mobile_des').css('display', 'block').animate({ opacity: 1 });
        });
      });
    }
    // Set your parent container that holds .check-price (adjust selector as needed)
    // const container = document.querySelector('.cart-drawer__footer, .cart-drawer');
    // const progress = document.querySelector('.progressBarInner'); // use this selector
    // const TARGET = 150;
    
    // if (container && progress) {
    //   let lastLoggedPrice = null;
    
    //   const logPriceIfChanged = () => {
    //     const priceEl = container.querySelector('.check-price');
    //     if (priceEl) {
    //       const priceText = priceEl.textContent.trim();
    //       const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    
    //       if (!isNaN(price) && price !== lastLoggedPrice) {
    //         const percent = Math.min((price / TARGET) * 100, 100).toFixed(2);
    //         console.log('Updated Total Price:', price, '| Progress:', percent + '%');
    //         const remaining = TARGET - price;

    //         // Apply width as percent of target
    //         setTimeout(()=>{
    //           if (price < TARGET) {
    //             $('#freeShippingText').text(`Only $${remaining.toFixed(2)} away from free shipping!`);
    //           } else {
    //             $('#freeShippingText').text(`You're eligible for free shipping!`);
    //           }
    //           $('.progressBarInner').css('width', `${percent}%`);
      
    //         },200)
    //         lastLoggedPrice = price;
    //       }
    //     }
    //   };
    
    //   logPriceIfChanged();
    
    //   const observer = new MutationObserver(logPriceIfChanged);
    
    //   observer.observe(container, {
    //     childList: true,
    //     subtree: true,
    //   });
    // }
// Set your free shipping goal
  const TARGET = 200;
  let lastLoggedPrice = 0;

  function logPriceIfChanged($container) {
    const $priceEl = $container.find('.check-price');
    if ($priceEl.length) {
      // 1. Get the full price text (e.g., "£142.63" or "€144,20")
      const priceText = $priceEl.text().trim();

      // 2. Extract the currency symbol
      const currencySymbol = priceText.replace(/[0-9.,]/g, '').trim();

      // 3. Get the number, handling BOTH . and ,
      const cleanedText = priceText.replace(/[^0-9.,]/g, '');

      // 4. Standardize the decimal for parsing.
      // Detect thousands vs decimal separator to handle $1,042.63 and €1.042,63 correctly.
      let parsableText;
      const hasComma = cleanedText.includes(',');
      const hasDot   = cleanedText.includes('.');
      if (hasComma && hasDot) {
        // Determine which comes last — that one is the decimal separator
        if (cleanedText.lastIndexOf('.') > cleanedText.lastIndexOf(',')) {
          // US format: 1,042.63 → strip thousands commas
          parsableText = cleanedText.replace(/,/g, '');
        } else {
          // EU format: 1.042,63 → strip thousands dots, swap decimal comma
          parsableText = cleanedText.replace(/\./g, '').replace(',', '.');
        }
      } else if (hasComma) {
        // Only comma present — it's the decimal separator (e.g. €142,63)
        parsableText = cleanedText.replace(',', '.');
      } else {
        parsableText = cleanedText;
      }

      // 5. Parse the displayed total (includes SI price when SI is checked)
      const price = parseFloat(parsableText);

      if (!isNaN(price) && price !== lastLoggedPrice) {
        /*
         * Shipping-insurance price must NOT count toward the free-shipping threshold.
         * Read the SI price (in cents) from the checked SI widget and subtract it
         * so the bar always reflects only real purchasable products.
         */
        const $siCheckedCard = $(document).find('.si-card.is-checked').first();
        const $siWrap = $siCheckedCard.length ? $siCheckedCard.closest('.si-wrap') : $();
        const siCents = $siWrap.length ? (parseInt($siWrap.data('price'), 10) || 0) : 0;
        const shippingPrice = Math.max(0, price - siCents / 100);

        const percent = Math.min((shippingPrice / TARGET) * 100, 100).toFixed(2);
        const remaining = TARGET - shippingPrice;

        let remainingText = remaining.toFixed(2);

        // Restore comma decimal format if the store uses it (e.g., €57,37)
        if (priceText.includes(',')) {
          remainingText = remainingText.replace('.', ',');
        }

        const remainingFormatted = `${currencySymbol}${remainingText}`;

        if (shippingPrice < TARGET) {
          $('.free-price').text(remainingFormatted);
          $('.free-inner').css('opacity', '1');
          $(".eligible").css('opacity', '0');
        } else {
          $('.free-inner').css('opacity', '0');
          $(".eligible").css('opacity', '1');
        }

        $('.progressBarInner').css('width', `${percent}%`);
        lastLoggedPrice = price;
      }
    }
  }

  function observeCartDrawer() {
    const container = document.querySelector('.cart-drawer__footer, .cart-drawer');

    if (container) {
      // Initial run
      logPriceIfChanged($(container));

      // Observe changes
      const observer = new MutationObserver(() => {
        setTimeout(()=>{
          logPriceIfChanged($(container));
        },100)
      });

      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initial observer setup
  observeCartDrawer();

  // Re-run observer setup every time cart drawer updates via AJAX
  $(document).on('ajaxComplete cart:updated cart:refreshed', function () {
    observeCartDrawer(); // Rebind in case DOM was replaced
  });

    $(document).on('click', '.quantity-wrapper .increment', function () {
  var $wrapper = $(this).closest('.quantity-wrapper');
  var $input = $wrapper.find('.quantity-input');
  var $lineItemQty = $(this).closest('line-item-quantity');
  var step = parseInt($input.attr('step')) || 1;
  var max = parseInt($input.attr('max')) || Infinity;
  var currentVal = parseInt($input.val()) || 0;

  if (currentVal + step <= max) {
    $input.val(currentVal + step);
    $lineItemQty.addClass('quantity-updating');
    $input[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
});

$(document).on('click', '.quantity-wrapper .decrement', function () {
  var $wrapper = $(this).closest('.quantity-wrapper');
  var $input = $wrapper.find('.quantity-input');
  var $lineItemQty = $(this).closest('line-item-quantity');
  var step = parseInt($input.attr('step')) || 1;
  var min = parseInt($input.attr('min')) || 0;
  var currentVal = parseInt($input.val()) || 0;

  if (currentVal - step >= min) {
    $input.val(currentVal - step);
    $lineItemQty.addClass('quantity-updating');
    $input[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
});

$(document).on('line-item:error', 'line-item-quantity', function () {
  $(this).removeClass('quantity-updating');
});

  })

// Refresh cart drawer on browser back/forward navigation.
// When the browser serves an HTTP-cached page (event.persisted = false, type = 'back_forward'),
// the cart drawer may show a stale state from before AJAX add-to-cart ran.
// Dispatching cart:refresh forces the theme to re-fetch the section and show the live cart.
window.addEventListener('pageshow', function (event) {
  if (event.persisted) return; // bfcache restore is already handled by the theme's _onPageShow
  try {
    var navEntries = performance.getEntriesByType('navigation');
    if (navEntries.length > 0 && navEntries[0].type === 'back_forward') {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  } catch (e) {}
});

// When a product gallery thumbnail is clicked, sync the variant picker color selection
document.addEventListener('click', function(e) {
  var thumbnail = e.target.closest('.product-gallery__thumbnail');
  if (!thumbnail) return;

  var gallery = thumbnail.closest('product-gallery');
  if (!gallery) return;

  // Thumbnail index in the full list (including hidden) matches .product-gallery__media index
  var allThumbnails = Array.from(gallery.querySelectorAll('.product-gallery__thumbnail'));
  var thumbnailIndex = allThumbnails.indexOf(thumbnail);
  if (thumbnailIndex < 0) return;

  var allMedia = Array.from(gallery.querySelectorAll('.product-gallery__media'));
  var targetMedia = allMedia[thumbnailIndex];
  if (!targetMedia) return;

  // Get the Shopify media ID from the media element
  var mediaId = targetMedia.getAttribute('data-media-id');
  if (!mediaId) return;

  // Read the variant→media map embedded by product-gallery.liquid
  var mapScript = gallery.querySelector('script[data-variant-media-map]');
  if (!mapScript) return;

  var variantMediaMap;
  try { variantMediaMap = JSON.parse(mapScript.textContent); } catch (err) { return; }

  // Look up which variant option values belong to this media ID
  var optionValues = variantMediaMap[mediaId];
  if (!optionValues || !optionValues.length) return; // image not tied to any variant

  var formId = gallery.getAttribute('form');
  var variantPicker = document.querySelector('variant-picker[form-id="' + formId + '"]');
  if (!variantPicker) return;

  var fieldsets = variantPicker.querySelectorAll('.variant-picker__option');

  // Change only option 1 (color) to preserve the user's current size/other selections.
  // optionValues[0] is the first option value name (e.g. "Sand", "Black").
  var colorValue = optionValues[0];
  var colorFieldset = fieldsets[0];
  if (!colorFieldset || !colorValue) return;

  var targetInput = null;
  var inputs = colorFieldset.querySelectorAll('input[data-option-position]');
  for (var j = 0; j < inputs.length; j++) {
    var input = inputs[j];
    var label = (input.labels && input.labels[0]) ||
                document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    if (!label) continue;
    if (label.textContent.trim().toLowerCase() === colorValue.toLowerCase()) {
      targetInput = input;
      break;
    }
  }

  if (!targetInput || targetInput.checked) return;
  targetInput.checked = true;
  targetInput.dispatchEvent(new Event('change', { bubbles: true }));
});

  document.addEventListener('DOMContentLoaded', function () {
  const emailInput = document.getElementById('CustomerEmail');
  const rememberCheckbox = document.getElementById('remember_me');

  // Load saved email if exists
  if (localStorage.getItem('rememberedEmail')) {
    emailInput.value = localStorage.getItem('rememberedEmail');
    rememberCheckbox.checked = true;
  }

  // Save email on form submit
 /* document.querySelector('form[action="/account/login"]').addEventListener('submit', function () {
    if (rememberCheckbox.checked) {
      localStorage.setItem('rememberedEmail', emailInput.value);
    } else {
      localStorage.removeItem('rememberedEmail');
    }
  });
*/

});

  document.addEventListener('DOMContentLoaded', function () {

   $('.account-nav__toggle').on('click', function () {
      $('.account-nav__menu').slideToggle();
      $('.account-nav__toggle svg').toggleClass('rotate');

    });
  });
  
  const observer = new MutationObserver(() => {
  const searchButton = document.getElementById("search-button");
  const searchInput = document.getElementById("search-input");

  if (searchButton && searchInput) {
    observer.disconnect(); // Stop watching after we find the elements

    searchButton.addEventListener("click", function () {
      const query = searchInput.value.trim();
      if (!query) {
        alert("Please enter a search term.");
        searchInput.focus();
        return;
      }
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    });

    searchInput.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        searchButton.click();
      }
    });
  }
});

// Start observing changes in the entire document body
observer.observe(document.body, { childList: true, subtree: true });
      
 document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("footer-newsletter");

    if (!form || !emailInput) return;

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const allowedDomains = [
      "gmail.com", "yahoo.com", "hotmail.com", "aol.com", "hotmail.co.uk", "hotmail.fr", "msn.com",
      "yahoo.fr", "wanadoo.fr", "orange.fr", "comcast.net", "yahoo.co.uk", "yahoo.com.br", "yahoo.co.in",
      "live.com", "rediffmail.com", "free.fr", "gmx.de", "web.de", "yandex.ru", "ymail.com", "libero.it",
      "outlook.com", "uol.com.br", "bol.com.br", "mail.ru", "cox.net", "hotmail.it", "sbcglobal.net",
      "sfr.fr", "live.fr", "verizon.net", "live.co.uk", "googlemail.com", "yahoo.es", "ig.com.br",
      "live.nl", "bigpond.com", "terra.com.br", "yahoo.it", "neuf.fr", "yahoo.de", "alice.it",
      "rocketmail.com", "att.net", "laposte.net", "facebook.com", "bellsouth.net", "yahoo.in", "hotmail.es",
      "charter.net", "yahoo.ca", "yahoo.com.au", "rambler.ru", "hotmail.de", "tiscali.it", "shaw.ca",
      "yahoo.co.jp", "sky.com", "earthlink.net", "optonline.net", "freenet.de", "t-online.de", "aliceadsl.fr",
      "virgilio.it", "home.nl", "qq.com", "telenet.be", "me.com", "yahoo.com.ar", "tiscali.co.uk",
      "yahoo.com.mx", "voila.fr", "gmx.net", "mail.com", "planet.nl", "tin.it", "live.it", "ntlworld.com",
      "arcor.de", "yahoo.co.id", "frontiernet.net", "hetnet.nl", "live.com.au", "yahoo.com.sg", "zonnet.nl",
      "club-internet.fr", "juno.com", "optusnet.com.au", "blueyonder.co.uk", "bluewin.ch", "skynet.be",
      "sympatico.ca", "windstream.net", "mac.com", "centurytel.net", "chello.nl", "live.ca", "aim.com", "bigpond.net.au"
    ];

    form.addEventListener("submit", function (e) {
      const email = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      // Format validation
      if (!emailRegex.test(email)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBannerMessage("Please enter a valid email address.", "error");
        emailInput.focus();
        return false;
      }

      // Domain restriction
      const domain = email.split("@")[1].toLowerCase();
      if (!allowedDomains.includes(domain)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBannerMessage(`Email domain '${domain}' is not valid.`, "error");
        $('.banner.banner--success.justify-center').hide()
        emailInput.focus();
        return false;
      }

      clearBannerMessage(); // optional: remove old message if valid
    });

    function showBannerMessage(message, status = "error") {
      clearBannerMessage();

      const banner = document.createElement("div");
      banner.className = `custom-newsletter-banner banner banner--${status}`;
      banner.setAttribute("role", "alert");
      banner.style.marginTop = "1rem";
      banner.innerText = message;

      form.appendChild(banner);
    }

    function clearBannerMessage() {
      const oldBanner = form.querySelector(".custom-newsletter-banner");
      if (oldBanner) oldBanner.remove();
    }
  });
  document.addEventListener("DOMContentLoaded", function () {
  const allowedDomains = [
    "gmail.com", "yahoo.com", "hotmail.com", "aol.com", "hotmail.co.uk", "hotmail.fr", "msn.com",
    "yahoo.fr", "wanadoo.fr", "orange.fr", "comcast.net", "yahoo.co.uk", "yahoo.com.br", "yahoo.co.in",
    "live.com", "rediffmail.com", "free.fr", "gmx.de", "web.de", "yandex.ru", "ymail.com", "libero.it",
    "outlook.com", "uol.com.br", "bol.com.br", "mail.ru", "cox.net", "hotmail.it", "sbcglobal.net",
    "sfr.fr", "live.fr", "verizon.net", "live.co.uk", "googlemail.com", "yahoo.es", "ig.com.br",
    "live.nl", "bigpond.com", "terra.com.br", "yahoo.it", "neuf.fr", "yahoo.de", "alice.it",
    "rocketmail.com", "att.net", "laposte.net", "facebook.com", "bellsouth.net", "yahoo.in", "hotmail.es",
    "charter.net", "yahoo.ca", "yahoo.com.au", "rambler.ru", "hotmail.de", "tiscali.it", "shaw.ca",
    "yahoo.co.jp", "sky.com", "earthlink.net", "optonline.net", "freenet.de", "t-online.de", "aliceadsl.fr",
    "virgilio.it", "home.nl", "qq.com", "telenet.be", "me.com", "yahoo.com.ar", "tiscali.co.uk",
    "yahoo.com.mx", "voila.fr", "gmx.net", "mail.com", "planet.nl", "tin.it", "live.it", "ntlworld.com",
    "arcor.de", "yahoo.co.id", "frontiernet.net", "hetnet.nl", "live.com.au", "yahoo.com.sg", "zonnet.nl",
    "club-internet.fr", "juno.com", "optusnet.com.au", "blueyonder.co.uk", "bluewin.ch", "skynet.be",
    "sympatico.ca", "windstream.net", "mac.com", "centurytel.net", "chello.nl", "live.ca", "aim.com", "bigpond.net.au"
  ];

  // Forms: footer and popup
  const forms = [
    document.getElementById("footer-newsletter"),
    document.querySelector("#newsletter-drawer form")
  ];

  forms.forEach((form) => {
    if (!form) return;

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton = form.querySelector('button[type="submit"]');
    if (!emailInput || !submitButton) return;

    form.addEventListener("submit", function (e) {
      const email = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      // Format validation
      if (!emailRegex.test(email)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBannerMessage(form, submitButton, "Please enter a valid email address.", "error");
        emailInput.focus();
        return false;
      }

      // Domain restriction
      const domain = email.split("@")[1].toLowerCase();
      if (!allowedDomains.includes(domain)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBannerMessage(form, submitButton, `Email domain '${domain}' is not valid.`, "error");
        document.querySelector('.banner.banner--success.justify-center')?.style?.setProperty("display", "none");
        emailInput.focus();
        return false;
      }

      clearBannerMessage(form);
    });
  });

  function showBannerMessage(form, submitButton, message, status = "error") {
    clearBannerMessage(form);

    const banner = document.createElement("div");
    banner.className = `custom-newsletter-banner banner banner--${status}`;
    banner.setAttribute("role", "alert");
    banner.style.marginTop = "0.75rem";
    banner.style.marginBottom = "0.75rem";
    banner.innerText = message;
submitButton.parentNode.insertBefore(banner, submitButton);
      setTimeout(()=>{
        $('.button__loader').css({
          'transform': 'none',
          'opacity': '0'
        });
        $(' button div').css({
          'transform': 'none',
          'opacity': '1'
        });
      },800)
    form.insertBefore(banner, submitButton);
  }

  function clearBannerMessage(form) {
    const oldBanner = form.querySelector(".custom-newsletter-banner");
    if (oldBanner) oldBanner.remove();
  }
});
      
  // document.addEventListener("DOMContentLoaded", function () {
  //   const form = document.querySelector('form[action*="/account?new_signup=true"]');
  //   const emailInput = form.querySelector('input[name="customer[email]"]');
  //   const submitButton = form?.querySelector('button.button--xl.button--outline.button--secondary.w-full');
  //   const allowedDomains = [
  //     "gmail.com", "yahoo.com", "hotmail.com", "aol.com", "hotmail.co.uk", "hotmail.fr", "msn.com",
  //     "yahoo.fr", "wanadoo.fr", "orange.fr", "comcast.net", "yahoo.co.uk", "yahoo.com.br", "yahoo.co.in",
  //     "live.com", "rediffmail.com", "free.fr", "gmx.de", "web.de", "yandex.ru", "ymail.com", "libero.it",
  //     "outlook.com", "uol.com.br", "bol.com.br", "mail.ru", "cox.net", "hotmail.it", "sbcglobal.net",
  //     "sfr.fr", "live.fr", "verizon.net", "live.co.uk", "googlemail.com", "yahoo.es", "ig.com.br",
  //     "live.nl", "bigpond.com", "terra.com.br", "yahoo.it", "neuf.fr", "yahoo.de", "alice.it",
  //     "rocketmail.com", "att.net", "laposte.net", "facebook.com", "bellsouth.net", "yahoo.in", "hotmail.es",
  //     "charter.net", "yahoo.ca", "yahoo.com.au", "rambler.ru", "hotmail.de", "tiscali.it", "shaw.ca",
  //     "yahoo.co.jp", "sky.com", "earthlink.net", "optonline.net", "freenet.de", "t-online.de", "aliceadsl.fr",
  //     "virgilio.it", "home.nl", "qq.com", "telenet.be", "me.com", "yahoo.com.ar", "tiscali.co.uk",
  //     "yahoo.com.mx", "voila.fr", "gmx.net", "mail.com", "planet.nl", "tin.it", "live.it", "ntlworld.com",
  //     "arcor.de", "yahoo.co.id", "frontiernet.net", "hetnet.nl", "live.com.au", "yahoo.com.sg", "zonnet.nl",
  //     "club-internet.fr", "juno.com", "optusnet.com.au", "blueyonder.co.uk", "bluewin.ch", "skynet.be",
  //     "sympatico.ca", "windstream.net", "mac.com", "centurytel.net", "chello.nl", "live.ca", "aim.com", "bigpond.net.au"
  //   ];
  //   if (!form || !emailInput) return;

  //   form.addEventListener("submit", function (e) {
  //     const email = emailInput.value.trim();
  //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  //     // Format validation
  //     if (!emailRegex.test(email)) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       showBannerMessage("Please enter a valid email address.", "error");
  //       emailInput.focus();
  //       return false;
  //     }

  //     // Domain restriction
  //     const domain = email.split("@")[1].toLowerCase();
  //     if (!allowedDomains.includes(domain)) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       showBannerMessage(`Email domain '${domain}' is not allowed.`, "error");
  //       emailInput.focus();
  //       return false;
  //     }

  //     clearBannerMessage(); // Clean up any old messages if all is good
  //   });

  //   function showBannerMessage(message, status = "error") {
  //     clearBannerMessage();

  //     const banner = document.createElement("div");
  //     banner.className = `custom-newsletter-banner banner banner--${status}`;
  //     banner.setAttribute("role", "alert");
  //     banner.style.marginBottom = "1rem";
  //     banner.innerText = message;

  //     // Insert the banner before the submit button
  //     submitButton.parentNode.insertBefore(banner, submitButton);
  //     setTimeout(()=>{
  //       $('.button__loader').css({
  //         'transform': 'none',
  //         'opacity': '0'
  //       });
  //       $('.custom-login button div').css({
  //         'transform': 'none',
  //         'opacity': '1'
  //       });
  //     },800)
  //   }

  //   function clearBannerMessage() {
  //     const oldBanner = form.querySelector(".custom-newsletter-banner");
  //     if (oldBanner) oldBanner.remove();
  //   }
  // });

  document.addEventListener("DOMContentLoaded", function () {
   
    const form = document.querySelector('form[action*="/account?new_signup=true"]');
    const emailInput = form?.querySelector('input[name="customer[email]"]');
    const birthdateInput = form?.querySelector('#birthdate');
    const submitButton = form?.querySelector('button.button--xl.button--outline.button--secondary.w-full');
    const allowedDomains = [
      "gmail.com", "yahoo.com", "hotmail.com", "aol.com", "hotmail.co.uk", "hotmail.fr", "msn.com",
      "yahoo.fr", "wanadoo.fr", "orange.fr", "comcast.net", "yahoo.co.uk", "yahoo.com.br", "yahoo.co.in",
      "live.com", "rediffmail.com", "free.fr", "gmx.de", "web.de", "yandex.ru", "ymail.com", "libero.it",
      "outlook.com", "uol.com.br", "bol.com.br", "mail.ru", "cox.net", "hotmail.it", "sbcglobal.net",
      "sfr.fr", "live.fr", "verizon.net", "live.co.uk", "googlemail.com", "yahoo.es", "ig.com.br",
      "live.nl", "bigpond.com", "terra.com.br", "yahoo.it", "neuf.fr", "yahoo.de", "alice.it",
      "rocketmail.com", "att.net", "laposte.net", "facebook.com", "bellsouth.net", "yahoo.in", "hotmail.es",
      "charter.net", "yahoo.ca", "yahoo.com.au", "rambler.ru", "hotmail.de", "tiscali.it", "shaw.ca",
      "yahoo.co.jp", "sky.com", "earthlink.net", "optonline.net", "freenet.de", "t-online.de", "aliceadsl.fr",
      "virgilio.it", "home.nl", "qq.com", "telenet.be", "me.com", "yahoo.com.ar", "tiscali.co.uk",
      "yahoo.com.mx", "voila.fr", "gmx.net", "mail.com", "planet.nl", "tin.it", "live.it", "ntlworld.com",
      "arcor.de", "yahoo.co.id", "frontiernet.net", "hetnet.nl", "live.com.au", "yahoo.com.sg", "zonnet.nl",
      "club-internet.fr", "juno.com", "optusnet.com.au", "blueyonder.co.uk", "bluewin.ch", "skynet.be",
      "sympatico.ca", "windstream.net", "mac.com", "centurytel.net", "chello.nl", "live.ca", "aim.com", "bigpond.net.au"
    ];
    // Set max date (today) on birthdate input
    if (birthdateInput) {
      birthdateInput.max = new Date().toISOString().split("T")[0];
    }

    if (!form || !emailInput || !birthdateInput || !submitButton) return;

    form.addEventListener("submit", function (e) {
      clearBannerMessage();

      const email = emailInput.value.trim();
      const birthdateValue = birthdateInput.value;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      // Email format validation
      if (!emailRegex.test(email)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBannerMessage("Please enter a valid email address.", "error");
        emailInput.focus();
        return false;
      }

      // Email domain restriction
      const domain = email.split("@")[1].toLowerCase();
      if (!allowedDomains.includes(domain)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBannerMessage(`Email domain '${domain}' is not valid.`, "error");
        emailInput.focus();
        return false;
      }

      // Date of birth validation
      if (!isValidBirthdate(birthdateValue)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBannerMessage("Please enter a valid date of birth. You must be at least 13 years old.", "error");
        birthdateInput.focus();
        return false;
      }
    });

    function isValidBirthdate(dateString) {
      if (!dateString) return false;

      const today = new Date();
      const birthDate = new Date(dateString);

      // Must not be in the future
      if (birthDate > today) return false;

      // Must be at least 13 years old
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      const isOldEnough =
        age > 13 ||
        (age === 13 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)));

      return isOldEnough;
    }

    function showBannerMessage(message, status = "error") {
      clearBannerMessage();

      const banner = document.createElement("div");
      banner.className = `custom-newsletter-banner banner banner--${status}`;
      banner.setAttribute("role", "alert");
      banner.style.marginBottom = "1rem";
      banner.style.padding = "1rem";
      banner.style.borderRadius = "0.5rem";
      banner.style.textAlign = "left";
      banner.style.color = status === "error" ? "#f83a3a" : "#f83a3a";
      banner.innerText = message;

      submitButton.parentNode.insertBefore(banner, submitButton);
      setTimeout(()=>{
        $('.button__loader').css({
          'transform': 'none',
          'opacity': '0'
        });
        $('.custom-login button div').css({
          'transform': 'none',
          'opacity': '1'
        });
      },800)
    }

    function clearBannerMessage() {
      const oldBanner = form.querySelector(".custom-newsletter-banner");
      if (oldBanner) oldBanner.remove();
    }

    
  });










  if (document.body.classList.contains('template-index') ||
    document.body.classList.contains('template-product')) {

  window.addEventListener('load', () => {
    const isDesktop = () => window.matchMedia("(min-width: 769px)").matches;

    document.querySelectorAll(".product-slider").forEach(slider => {
      const slides = slider.querySelectorAll(".slide");
      if (slides.length < 2) return;

      const first = slides[0];
      const second = slides[1];

      first.addEventListener("mouseenter", () => {
        if (!isDesktop()) return;
        first.classList.remove("active");
        second.classList.add("active");
      });

      slider.addEventListener("mouseleave", () => {
        slides.forEach(s => s.classList.remove("active"));
        first.classList.add("active");
      });
    });
  });
}









// en-gb redirect moved to theme.liquid where Liquid tags are evaluated
